import React, { useState, useEffect } from "react";
import "./projetdetail.css";
import loadingImage from "../../assets/images/disque.png";
import { Link, useParams, Navigate } from "react-router-dom";
import { API_ROUTES } from "../../utils/constant";
import axios from "axios";

const ProjetDetail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [projet, setProjet] = useState({});
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_ROUTES.PROJETS}/${id}`, {
          headers: { Authorization: localStorage.getItem("token") },
        });

        setTimeout(() => {
          setProjet(response.data);
          setIsLoading(false);
        }, 1000);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [id]);

  const currentTheme = localStorage.getItem("theme");

  useEffect(() => {
    const projetSelectElement = document.querySelector(".projet-detail");

    if (projetSelectElement) {
      if (currentTheme === "light") {
        projetSelectElement.classList.remove("dark-mode-detail");
        projetSelectElement.classList.add("light-mode-detail");
      } else {
        projetSelectElement.classList.remove("light-mode-detail");
        projetSelectElement.classList.add("dark-mode-detail");
      }
    }
  }, [currentTheme]);

  if (isLoading) {
    return (
      <div className="loading">
        <img
          src={loadingImage}
          alt="Loading"
          className="loading-image rotating"
        />
        <p>Chargement...</p>
      </div>
    );
  }

  if (!projet._id) {
    return <Navigate to="/notFound" />;
  }

  return (
    <div className="projet-detail">
      <div className="projet-select">
        <h2>{projet.title}</h2>
        <img src={projet.image} alt={projet.title} />
        <p>{projet.description}</p>
        {projet.url && (
          <a href={projet.url} target="_blank" rel="noopener noreferrer">
            Voir le projet
          </a>
        )}
        {projet.github && (
          <a href={projet.github} target="_blank" rel="noopener noreferrer">
            Voir le code
          </a>
        )}
        <p>{projet.technologies}</p>
        <Link to="/projets">Retour aux projets</Link>
      </div>
    </div>
  );
};

export default ProjetDetail;
